module.exports = __webpack_public_path__ + "static/img/2.9397225.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/zh/2.png
// module id = jjui
// module chunks = 0